import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/memberList',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/MemberListContainer',
      './modules/memberList'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const MemberList = require('./containers/MemberListContainer').default
      const actions = require('./modules/memberList')
      const reducer = require('./modules/memberList').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'memberList', reducer: reducer })

      store.dispatch(actions.fetchMembers(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, MemberList)

    /* Webpack named bundle   */
    }, 'memberList')
  }
})




// WEBPACK FOOTER //
// ./src/routes/MemberList/index.js